<div class="container-fluid">
  <div class="row">
    <div class="col-12" id="login-page">
      <div class="col-lg-5 offset-md-7">
        <div id="formContent">
          <img src="../../../assets/img/main-logo.png" alt="">
          <form name="form-forgotpassword" (ngSubmit)="f.form.valid && forgotPassword()" #f="ngForm" novalidate>
            @if (errorMessage) {
              <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
            }
            <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !email.valid }">
              <input type="text" class="form-control input-text-custom"
                id="email" name="email" [(ngModel)]="user.email"
                placeholder="email"
                #email="ngModel" required/>
                @if (f.submitted && !email.valid) {
                  <div class="help-block">email is required.</div>
                }
              </div>

              <input type="submit" class="fadeIn fourth float-end" value="Send">
            </form>

            <div id="formFooter">
              <a class="underlineHover" [routerLink]="['/login']">Log in</a>
            </div>

          </div>

        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
